import { IOfficeAppliancesType } from "../types/index";
import { addType } from "../api/addType";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "components/toastNotification";

const useAddType = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (typeNewData: IOfficeAppliancesType) => addType(typeNewData),
    {
      onSuccess: (res) => {
        if (res === "Duplicate") {
          toast.fire("Failed", "Type already exist", "error");
        } else {
          toast.fire("Success", "Type added successfully", "success");
        }
        queryClient.invalidateQueries(["GetTypes"]);
      },
      onError: () => {
        toast.fire("Failed", "Failed to add Type", "error");
      },
    }
  );

  return mutate;
};
export default useAddType;
